import Vue from 'vue';
import VideoGallery from './VideoGallery.vue';

const InitVideoGalleryVue = {
    init() {
        if (document.getElementById('vue-video-gallery')) {
            new Vue({
                el: '#vue-video-gallery',
                components: {
                    'video-gallery': VideoGallery,
                },
            });
        }
    },
};

export default InitVideoGalleryVue;
